import React from 'react';
import Link from 'Components/Link';

import styles from './BackLink.scss';
import AppsIcon from './breadcrumb-apps-icon.svg';
import ClassesIcon from './list-icon.svg';
import ArrowIcon from './breadcrumb-back-arrow.svg';
import { ROUTES } from '../../settings/route-strings';

const getIcon = route => {
  const props = {
    className: 'BackLink__type-icon',
  };
  switch (route) {
    case ROUTES.EXPLORE:
      return <AppsIcon {...props} />;
    case ROUTES.CLASSES:
      return <ClassesIcon {...props} />;
    default:
      return null;
  }
};

const BackLink = ({ route, label, type }) => {
  return (
    <Link to={route} className={`BackLink BackLink--${type}`}>
      <ArrowIcon className="BackLink__arrow-icon" />
      {getIcon(route)}
      <div className="BackLink__label">{label}</div>
    </Link>
  );
};

export default BackLink;
